import { Modal } from 'antd';
import moment from 'moment';
import 'moment/locale/ko';
import React, { useEffect, useState } from 'react';
import { withAlert } from 'react-alert';
import { connect } from 'react-redux';
import { httpGet, httpUrl } from '../../api/httpClient';
import {
  dosiguCodeReplace,
  paymentMethodString,
  reserveOrderProcessStatusCode,
  modalStyle
} from '../../lib/util/codeUtil';
import { comma } from '../../lib/util/numberUtil';
import Const from "../../const";

const ReserveList = (props) => {
  const [list, setList] = useState([]);

  useEffect(async () => {
    await getListAsync();
  }, []);

  const getListAsync = async () => {
    try {
      const res = await httpGet(httpUrl.getReserveOrderList, [], {});
      if (res.data.result !== 'SUCCESS') {
        Modal.warn({
          title: '조회 오류',
          content:
            '예약주문 정보를 가져오는데 실패했습니다. 잠시 후 다시 시도해주세요.',
          ...modalStyle,
        });
        return;
      }
      // console.log(res);
      setList(res.data.reserveOrders);
    } catch (e) {
      Modal.warn({
        title: '조회 오류',
        content:
          '예약주문 정보를 가져오는데 실패했습니다. 잠시 후 다시 시도해주세요.',
        ...modalStyle,
      });
    }
  };

  const skinType = Const.skinType.toUpperCase();

  return (
    <div className="delivery-element-complete">
      <div className="delivery-element-reserve-all">
        <div className="delivery-element-reserve-block">
          <div className="delivery-element-reserve-block-menu">
            <div className="delivery-element-reserve-block-menu-text mobileoff">
              주문번호
            </div>
            <div className="delivery-element-reserve-block-menu-text mobileoff">
              신청일시
            </div>
            <div className="delivery-element-reserve-block-menu-text mobileoff">
              예약일시
            </div>
            <div className="delivery-element-reserve-block-menu-text del-com3">
              고객정보
            </div>
            <div className="delivery-element-reserve-block-menu-text del-com3">
              주문금액
            </div>
            <div className="delivery-element-reserve-block-menu-text mobileoff">
              결제수단
            </div>
            <div className="delivery-element-reserve-block-menu-text ">
              메모
            </div>
            <div className="delivery-element-reserve-block-menu-text mobileoff">
              상태
            </div>
          </div>
        </div>
        <div className="completeList-wrapper">
          {(!list || list.length === 0) && (
            <div style={{ textAlign: 'center', padding: '50px' }}>
              내역이 없습니다.
            </div>
          )}
          {list &&
            list.map((row, index) => (
              <div
                key={index}
                className={
                  'delivery-element-reserve-block-field' +
                  (index % 2 === 0 ? '' : ' odd')
                }>
                <div className="delivery-element-reserve-block-field-text mobileoff">
                  {row.idx}
                </div>
                <div className="delivery-element-reserve-block-field-text mobileoff">
                  {row.createDate &&
                    moment(row.createDate).format('YYYY-MM-DD HH:mm')}
                </div>
                <div className="delivery-element-reserve-block-field-text mobileoff">
                  {row.reserveDate &&
                    moment(row.reserveDate).format('YYYY-MM-DD HH:mm')}
                </div>
                <div
                  style={{
                    fontSize: '1.1rem',
                    letterSpacing: (-1 / 20) * row.destAddr3.length,
                  }}
                  className="delivery-element-reserve-block-field-text del-comsub3">
                  {`${
                    row.destAddr3
                      ? dosiguCodeReplace(row.destAddr3)
                      : dosiguCodeReplace(row.destAddr1)
                  } ${row.destAddr2} (${row.custPhone})`}
                </div>
                <div className="delivery-element-reserve-block-field-text">
                  {comma(row.orderPrice)}원
                </div>
                <div className="delivery-element-reserve-block-field-text mobileoff">
                  {row.reserveOrderPayment
                    ? paymentMethodString[row.reserveOrderPayment.paymentMethod]
                    : ''}
                </div>
                <div className="delivery-element-reserve-block-field-text mobileoff">
                  {row.custMessage}
                </div>
                <div className="delivery-element-reserve-block-field-text mobileoff">
                  <div className={skinType === "GOGOIT" ? 'gogoit-delivery-element-reserve-block-field-text7' :'delivery-element-reserve-block-field-text7'}>
                    {reserveOrderProcessStatusCode[row.processStatus]}
                  </div>
                </div>
                <div className="delivery-element-reserve-block-field-text mobile">
                  <div className={skinType === "GOGOIT" ?'gogoit-delivery-element-reserve-block-field-text7' : 'delivery-element-reserve-block-field-text7'}>
                    {reserveOrderProcessStatusCode[row.processStatus]}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { posReducer } = state;
  return { posReducer };
};
const mapDispatchToProps = null;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAlert()(ReserveList));
